// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import ReactGA from "react-ga4";

var generalCommonJS = require("../../../js/generalCommon.js")

// Advisory - Energy Billing
const Connectivity = () => {
  
  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Conectividad"     
    document.querySelector('meta[name="description"]').setAttribute("content", "¿Tienes problemas de conectividad con tus dispositivos o no sabes cómo llevar el WIFI a un sitio concreto de tu instalación?");
    
    console.log("Abro asesoramiento para problemas de conectividad.")    

  });

  function mostrarOcultarVideo(Video){

    var div = document.getElementById("div"+Video)

    if(div.className.includes(" hidden")){ 
      div.className = div.className.replaceAll(" hidden", "")       
      document.getElementById("boton"+Video).innerHTML = "Ocultar video"
    }
    else{ 
      div.className += " hidden"       
      document.getElementById("boton"+Video).innerHTML = "Aquí tienes un video de su instalación..."
    }

  }

  return (      
    <main className="no-background">

      <section className="step">
        <div className="content-wrapper">          

              <div className="vertical gap-02">
                <p>Si tu problema es que <strong>tus dispositivos pierden la conexión de forma frecuente</strong> seguramente sea porque tienes muchos y los routers normales empiezan a tener problemas para gestionarlos cuando se pasa de 20 (esto incluye teléfonos móviles, ordenadores, etc...). Para resolver esto lo mejor es utilizar enrutadores de malla, como el que te muerstro a continuación. Te permitirán tener 45 dispositivos por nodo y además gestionará automáticamente el ancho de banda entre ellos.</p>
              </div>

              <div>
                <a href="https://www.amazon.es/TENDA-Nova-MW6-Sistema-Integral/dp/B078MZTRBS/" className="selector icon-wrapper no-icon xxl" target="_blank" rel="noopener noreferrer" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', 'XSELL - NOVA-MW6', "", "")}>
                  <figure className="avatar size-xxl"><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwxRod2uFux5Ky6MzTAk94zsNIN1FRKu8ZWg&s" alt=""/></figure>
                  <div className="content vertical gap-02">
                    <h1 className="headline-03">Tenda Nova MW6</h1>                    
                    <p>Pack de 2 nodos que soporta 90 dispositivos y cubre 330 m²</p>
                  </div>
                </a>
                <div className="page">
                  <button id="botonRouterMalla" className="link icon horizontal-center fill" onClick={() => mostrarOcultarVideo("RouterMalla") }>Aquí tienes un video de su instalación...</button>
                </div>
              </div>
                                
              <div id="divRouterMalla" className="video-wrapper hidden">
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/CdDs2zyV4qQ" title="YouTube video player" frameBorder="0" allow="accelerometer;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowFullScreen></iframe>
              </div>

              <p>Si lo que necesitas es <strong>llevar internet a una zona lejana de tu instalación, lo mejor es que uses PLC</strong>, que consiste en llevar la señal de internet a través de la red eléctrica. Esto es muy util, por ejemplo, en instalaciones con varias plantas o para llevar internet de una casa al portal de una comunidad de vecinos.</p>

              <div>
                <a href="https://amzn.eu/d/697McO4" className="selector icon-wrapper no-icon xxl" target="_blank" rel="noopener noreferrer" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', 'XSELL - AV600-PLC', "", "")}>
                  <figure className="avatar size-xxl"><img src="https://m.media-amazon.com/images/I/51J+VQPg0JL.jpg" alt=""/></figure>
                  <div className="content vertical gap-02">
                    <h1 className="headline-03">Kit AV600 PLC Wi-Fi</h1>                    
                    <p>Conecta uno en un enchufe cercano al router y el otro donde quieras tener internet.</p>
                  </div>
                </a>
                <div className="page">
                  <button id="botonExtensorComunidadDeVecinos" className="link icon horizontal-center fill" onClick={() => mostrarOcultarVideo("ExtensorComunidadDeVecinos") }>Aquí tienes un video de su instalación...</button>
                </div>
              </div>
                                
              <div id="divExtensorComunidadDeVecinos" className="video-wrapper hidden">
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/IJi0GsahOrA" title="YouTube video player" frameBorder="0" allow="accelerometer;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowFullScreen></iframe>
              </div>
              
        </div>        

      </section>

    </main>
  )
}

export default Connectivity